import React from "react"
import sizeMe from "react-sizeme"
import StackGrid, { transitions } from "react-stack-grid"
import styled from "styled-components"
import { FullWrapper } from "Styles"
import { theme } from "Theme"
import { SectionTestimonials } from "Components"
const { fadeDown } = transitions

const Grid = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: ${theme.layout.base};
`

const TestimonialsGrid = ({ data }) => {
  return (
    <FullWrapper>
      <Grid>
        <StackGrid
          monitorImagesLoaded
          onLayout={() => {
            // console.log("SIZE: ", size)
          }}
          className={"stack-container"}
          columnWidth={374}
          // columnWidth={width <= 768 ? "100%" : "33.33%"}
          gutterWidth={24}
          gutterHeight={24}
          duration={0}
          component={"div"}
          itemComponent={"div"}
          appear={fadeDown.appear}
          appeared={fadeDown.appeared}
          enter={fadeDown.enter}
          entered={fadeDown.entered}
          leaved={fadeDown.leaved}>
          {data.edges.map((testimonial, i) => {
            let cardTestimonialCategoryClass
            // if (selectedCategory === "ALL") {
            //   cardTestimonialCategoryClass = classNames("testimonial-category", {
            //     hide: false,
            //   })
            // } else {
            //   const isSelectedCategory = selectedCategory === testimonial.category
            //   cardTestimonialCategoryClass = classNames("testimonial-category", {
            //     hide: !isSelectedCategory,
            //   })
            // }
            return (
              <SectionTestimonials
                key={i}
                data={testimonial}
                className={`${cardTestimonialCategoryClass}`}
                track={"Testimonial"}
              />
            )
          })}
        </StackGrid>
      </Grid>
    </FullWrapper>
  )
}

export default sizeMe()(TestimonialsGrid)
